<template>
    
    <div class="visual_fakkel mx-auto">

        <svg version="1.1" id="Laag_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 387.5 168.5" style="enable-background:new 0 0 387.5 168.5;" xml:space="preserve">

        <rect x="335.5" y="5.9" class="st0" width="44.5" height="83.7"/>
        <path v-if="flame" class="st1" d="M349,86.2c-1.9-2.1-3.7-4.3-4.9-6.9c-1.2-2.8-1.5-6-0.9-9.1c0.6-3,2-5.9,3.9-8.4c-0.2,2.1,0.6,4.3,2,5.9
            c-0.9-4.1,0.5-8.5,3.2-11.7s6.4-5.3,10.3-6.8c-2,2-2.2,5.2-1.4,8s2.4,5.1,3.8,7.5c1.4,2.5,2.8,5,2.9,7.8c0.8-1.4,1.6-2.9,2.1-4.5
            s0.8-3.3,0.3-4.9c1.5,1.9,2.4,3.7,2.8,6.1c0.4,2.4,0.3,4.8,0.1,7.2c-0.3,2.6-1,5.3-2.5,7.5c-1.7,2.6-4.4,4.5-7.4,5.5
            C358.2,90.4,353,89.6,349,86.2z"/>
        <path v-if="flame" class="st2" d="M355.5,89.3c6.9,2.7,13.8-5.5,10-11.9c0-0.1-0.1-0.1-0.1-0.2c0.3,3.5-0.5,6-2.1,7.4c0.9-2,0.2-4.4-0.8-6.4
            s-2.5-3.7-3.6-5.6c-1.1-2-2-4.2-1.4-6.3c-2,1.5-3.5,3.8-4.1,6.3s-0.2,5.2,0.9,7.5c-1.3-0.9-2.2-2.5-2.3-4.1
            c-1.4,1.6-2.2,3.7-2.1,5.8C349.9,85.2,352.5,88.1,355.5,89.3z"/>
        <rect x="346.1" y="89.7" width="24" height="8.1"/>
        <line class="st3" x1="6.9" y1="160.2" x2="358.7" y2="160.2"/>
        <line class="st3" x1="358.2" y1="160.6" x2="358.2" y2="90.9"/>
        <rect x="207.7" y="131.6" class="st4" width="34.6" height="15.2"/>
        <line class="st3" x1="225" y1="146.8" x2="225" y2="160.2"/>
        <rect x="210.6" y="136.1" class="st5" width="28.7" height="8.1"/>
        <text transform="matrix(1 0 0 1 210.584 142.5088)" class="st6 st7">{{network_preasure}}</text>
        <rect x="246.6" y="135.1" class="st5" width="28.7" height="8.1"/>
        <text transform="matrix(1 0 0 1 246.5762 142.6367)" class="st6 st8">m bar</text>
        <rect x="340.7" y="14.9" class="st5" width="23.4" height="13.6"/>
        <text transform="matrix(1 0 0 1 340.7859 18.4056)" class="st9 st10">{{ getOnOff() }}</text>
        <text transform="matrix(1 0 0 1 240.7859 18.4056)" class="st9 st11">{{ lastModified }}</text>
        </svg>



    </div>

</template>

<style scoped>

    .st0{fill:#F6F6F6;stroke:#000000;stroke-miterlimit:10;}
	.st1{fill:#EE715C;}
	.st2{fill:#FFD25F;}
	.st3{fill:none;stroke:#000000;stroke-miterlimit:10;}
	.st4{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}
	.st5{fill:none;}
	.st7{font-size:9px;}
	.st8{font-size:10.5883px;}
	.st10{font-size:10px;}
	.st11{font-size:10px; }

    .visual_fakkel {
        max-width: 600px;
    }
</style>


<script>

import helpers from "@/helpers";
import moment from "moment-timezone" ;

export default {
    
    data () {
        return {
            flame: false,
            network_preasure: null,
            lastModified: null
        }
    },
    props: {
        device: {
            type: Object,
            required: false,
            default: null
        },
    },
    methods: {

        getOnOff(){

            if(this.flame){
                return this.$t('On');
            }else{
                return this.$t('Off');
            }
            
        }

    },
    created() {

        var _this = this ; 

        // Get tags
        this.device.db.collection('tags').onSnapshot(function(querySnapshot) {

            querySnapshot.forEach(function(doc) {

                let tag = doc.data() ;
                tag.id = doc.id ; 

                // status
                if(tag.id == '416c6eb7994d477db559'){

                    if(tag.value == '3'){
                        _this.flame = true ;
                    }else{
                        _this.flame = false ;
                    }

                    if(tag.last_updated){
                         _this.lastModified  = moment.unix(tag.last_updated).tz("Europe/Amsterdam").format("DD-MM-YYYY HH:mm") ;
                    }

                }

                // network preasure
                if(tag.id == 'b5d2a37fd2ff42f78310'){
                    
                    _this.network_preasure = Math.round(helpers.get_tagValue(tag, true)) ; 

                    // $(".visual_buffer_network_pressure").text(tag.data().value) ;
                }

            });

        });

    }

}

</script>